// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"52cbc913","455":"606052a8","977":"e61ea0f6"}[chunkId] + ".chunk.js";
};